<template>
  <div class="body">
    <div class="main_container">
      <training-header :appConfig = "appConfig"  ></training-header>

      <!-- page content -->
      <div class="right_col" role="main" style="margin-left: 2px;">
        <div class="row px-4 pt-4">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel">
              <div class="x_content">
                <div class="process_steps">
                  <ul class="steps">
                    <li class="active">
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Download</span>
                      </div>
                    </li>
                    <li class="active">
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Customize</span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Complete</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel">
              <div class="x_title">
                <h2 style="font-weight: 600;">Generate and customize your agenda</h2>
                <a
                  href
                  class="btn btn-md download-btn"
                  id="btn_customclick"
                  data-toggle="modal"
                  style="color: #f4f4f4; text-decoration: underline;"
                  data-target="#myModal"
                >
                  <i class="fa fa-cloud-download" aria-hidden="true"></i> Download your agenda
                </a>
                <p></p>

                <div class="clearfix"></div>
              </div>
              <div class="x_content">
                <div class="dashboard-widget-content">
                  <div class="form-group">
                    <label
                      class="control-label col-md-3 col-sm-3 col-xs-12"
                      style="font-weight: 500;font-size: 15px;margin-top: 8px;"
                    >What time do you want to start the session?</label>

                    <div class="col-md-2 col-sm-2 col-xs-12">
                      <div class="input-group">
                        <span class="input-group-addon">
                          <i class="fa fa-clock-o" aria-hidden="true" style="font-size: 1.4em; padding-top:3px;"></i>
                        </span>
                        <!-- <input
                          type="text"
                          class="form-control timepicker"
                          id="session_sttime"
                          name="session_sttime"
                          placeholder
                        /> -->
                        <vue-timepicker :minute-interval="30" close-on-complete v-model="selectedTime"></vue-timepicker>
                      </div>
                    </div>
                  </div>

                  <table class="table table-bordered table-striped" id="example">
                    <thead>
                      <!-- <tr style="background: #dadce8;"> -->
                      <tr>
                        <th>MODULE</th>
                        <th>FACILITATOR</th>
                        <th>FROM</th>
                        <th>TO</th>
                        <th>TOPIC</th>
                        <th>GOALS</th>
                        <th>REQUIREMENTS</th>
                      </tr>
                    </thead>
                    <tbody v-if="masterAgenda">
                      <tr>
                          <td></td>
                          <td></td>
                          <td>
                          </td>
                          <td>
                          </td>
                          <td></td>
                          <td>Registration</td>
                          <td></td>
                      </tr>
                      <template v-for="(agenda, i) in masterAgenda">
                        <tr :key="i" v-if="agenda.masterAgendaId == null" :style="{'backgroundColor': agenda.colorCode}">
                          <td>{{agenda.module}}</td>
                          <td>{{agenda.facilatior}}</td>
                          <!-- <td v-if="masterLen % i != 0">{{masterLen}}</td> -->
                          <td v-if="agenda.fromTime">
                            <input type="text" id="regfrom" name="regfrom" :value="agenda.fromTime">
                          </td>
                          <td v-else>
                            <input type="text" id="regfrom" name="regfrom" disabled>
                          </td>
                          <td v-if="agenda.toTime">
                            <input type="text" id="regto" name="regto" :value="agenda.toTime">
                          </td>
                          <td v-else>
                            <input type="text" id="regto" name="regto" disabled>
                          </td>
                          <td>{{agenda.topic}}</td>
                          <td>{{agenda.goals}}</td>
                          <td>{{agenda.requirements}}</td>
                        </tr>
                        <tr :key="i" v-else>
                          <td>{{agenda.module}}</td>
                          <td>{{agenda.facilatior}}</td>
                          <!-- <td v-if="masterLen % i != 0">{{masterLen}}</td> -->
                          <td v-if="agenda.fromTime">
                            <input type="text" id="regfrom" name="regfrom" :value="agenda.fromTime">
                          </td>
                          <td v-else>
                            <input type="text" id="regfrom" name="regfrom" disabled>
                          </td>
                          <td v-if="agenda.toTime">
                            <input type="text" id="regto" name="regto" :value="agenda.toTime">
                          </td>
                          <td v-else>
                            <input type="text" id="regto" name="regto" disabled>
                          </td>
                          <td>{{agenda.agenda}}</td>
                          <td>{{agenda.goals}}</td>
                          <td>{{agenda.requirements}}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div>
                    <div style="text-align: center; margin-bottom: 3%;margin-top: 1%; padding-bottom:5%;">
                      <!-- <button type="submit">Submit form</button> -->

                      <router-link :to="{ name: 'facilitator-course', params: { facilitatorObj: facilitatorObj ,appConfig: appConfig}}"   class="btn-bottom" style="margin-right: 5%;">
                        <i
                          class="fa fa-angle-double-left"
                          aria-hidden="true"
                          style="padding-right: 1%;"
                        ></i> Previous
                      </router-link>
                      <a
                        href="#"
                        class="btn-bottom"
                        role="button"
                        style="color: #3471CE;"
                        @click="checkTime"
                      >
                        Next
                        <i
                          class="fa fa-angle-double-right"
                          aria-hidden="true"
                          style="padding-left: 1%;"
                        ></i>
                      </a>

                      <!-- <a href="login.html" class="btn btn-cust1 btn-md btn3d" role="button">Skip to Login</a> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal -->
          <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog modal-xl">
              <!-- Modal content-->
              <div class="modal-content">
                <div class="modal-header">

                  <h4 class="modal-title">Generate your agenda</h4>

                <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                  <export-excel :data = "items">
                    <button class="btn btn-outline-secondary excel_download_btn" type="button">Excel</button>
                  </export-excel>
                  <b-table striped bordered hover :items="items"></b-table>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /page content -->

      <!-- footer content -->
      <training-footer :appConfig="appConfig"></training-footer>
      <!-- /footer content -->
    </div>

  </div>
</template>
<script>
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import ApiServices from '../service/ApiServices';
import moment from 'moment';
export default {
    components: {
        trainingHeader,
        trainingFooter,
        VueTimepicker
    },
    data(){
      return {
        facilitatorObj:{},
        appConfig:{},
        selectedTime: '',
        masterAgenda: null,
        masterLen: null,
        items: [
          { MODULE: '', FACILITATOR: '', FROM: '', TO: '', GOALS: '', TOPIC: 'Registration' }
        ],
        fields: [
          {
            key: 'MODULE',
            label: 'MODULE',
            sortable: true
          },
          {
            key: 'FACILITATOR',
            label: 'FACILITATOR'
          },
          {
            key: 'FROM',
            label: 'FROM'
          },
          {
            key: 'TO',
            label: 'TO'
          },
          {
            key: 'GOALS',
            label: 'GOALS'
          },
          {
            key: 'TOPIC',
            label: 'TOPIC'
          }
        ],
        divisor: ''
      }
    },
    methods: {
      getUserAgenda(){
          let selectedAgenda = JSON.parse(localStorage.getItem("selectedAgendas"));
        let masterAgenda = this.$route.params.facilitatorObj.agenda;
        let newAgenda = []
        this.divisor = Math.round(Math.sqrt(masterAgenda.length))
        let breakAgenda = {agenda: "COFFEE BREAK",
                          agendaId: null,
                          colorCode: "#ffa65b99",
                          facilatior: "",
                          goals: "",
                          masterAgendaId: null,
                          module: "",
                          recommendedDuration: "",
                          requirements: "",
                          topic: "COFFEE BREAK",
                          topicId: null,
                          typeOfSession: "",
                          selected: true,
                          durationSelected: 15}
        //console.log(this.divisor)
        var count = 0
        masterAgenda.forEach((agenda, i)=>{
          agenda['selected'] = false
          selectedAgenda.forEach((selected)=>{
            if(agenda.masterAgendaId == selected.masterAgendaId){
              agenda['selected'] = selected.selected
              agenda['durationSelected'] = selected.duration
            }
          })
          if(i%this.divisor == 0 && i != 0){
            var obj = JSON.parse(JSON.stringify(breakAgenda))
            if(count == 1){
              obj.agenda = 'LUNCH BREAK'
              obj.topic = 'LUNCH BREAK'
              obj.colorCode = '#aeceea'
            }else{
              obj.agenda = 'COFFEE BREAK'
              obj.topic = 'COFFEE BREAK'
            }
            newAgenda.push(obj)
            this.items.push(
              { MODULE: obj.module, FACILITATOR: obj.facilatior, FROM: obj.fromTime, TO: obj.toTime, GOALS: obj.goals, TOPIC: obj.agenda }
            )
            count++
          }
          newAgenda.push(agenda)
          this.items.push(
            { MODULE: agenda.module, FACILITATOR: agenda.facilatior, FROM: agenda.fromTime, TO: agenda.toTime, GOALS: agenda.goals, TOPIC: agenda.agenda }
          )
        })
        this.masterAgenda = newAgenda
        // this.masterAgenda = masterAgenda
        console.log(newAgenda)
      },
      selectedMasterAgenda(){
        this.items = [{ MODULE: '', FACILITATOR: '', FROM: '', TO: '', GOALS: '', TOPIC: 'Registration' }]
        let startTime = this.selectedTime
        let fromTime = '', toTime = ''
        let j = 0
        this.masterAgenda.forEach((agenda, i)=>{
          if(agenda.selected){
            j++;
            if(j == 1){
              fromTime = startTime
              toTime = moment.utc(startTime,'HH:mm').add(agenda.durationSelected,'minutes').format('HH:mm')
            }else{
              fromTime = toTime
              toTime = moment.utc(toTime,'HH:mm').add(agenda.durationSelected,'minutes').format('HH:mm')
            }
            agenda['startTime'] = startTime
            agenda['fromTime'] = fromTime
            agenda['toTime'] = toTime
          }
          this.items.push(
            { MODULE: agenda.module, FACILITATOR: agenda.facilatior, FROM: agenda.fromTime, TO: agenda.toTime, GOALS: agenda.goals, TOPIC: agenda.agenda }
          )
        })
        console.log(this.masterAgenda)
        this.masterLen = this.masterAgenda.length
        ApiServices.RestPostCall('api/avenir/training/saveUserAgenda',{"userAgenda": this.masterAgenda}).then(res=>{
            console.log(res)
        })
        localStorage.setItem("userAgenda",JSON.stringify(this.masterAgenda));
        this.$root.loading = false;
      },
      checkTime(){
        if(this.selectedTime != ''){
          // this.$router.push("/training-agenda");
            this.$router.push({ name: 'training-agenda', params: { facilitatorObj: this.facilitatorObj,appConfig: this.appConfig } })
        }else{
          Swal.fire({
            text: "Please select time!",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
          })
        }
      }
    },
    mounted(){

      if(this.$route.params.facilitatorObj){
      this.facilitatorObj = this.$route.params.facilitatorObj
    }
      if(this.$route.params.appConfig){
      this.appConfig = this.$route.params.appConfig
      }

        this.getUserAgenda()
    },
    watch: {
      selectedTime(time){
        if(time.split(':')[0] != 'HH' && time.split(':')[1] != 'mm'){
          this.$root.loading = true;
          this.selectedMasterAgenda()
        }
      }
    }
}
</script>
<style scoped>
    .x_panel {
        background-color: #fff;
        border: 0px solid transparent;
        padding:0;
        border-radius: 7px;
    }
    .x_title {
        border-bottom: 0px solid #E6E9ED;
        padding: 15px 18px;
        background-color: #b0b0b0;
        color: #fff;
        border-radius: 7px 7px 0 0;
        position: relative;
    }
    .x_content {
        padding: 0 25px 6px;
    }
    .download-btn{
        position: absolute;
        right: 18px;
    }
    .vue__time-picker input.display-time{
      height: 2.83em !important;
    }
    .modal-title{
      font-size: 18px;
    }
    .excel_download_btn{
      position: relative;
    display: inline-block;
    box-sizing: border-box;
    margin-right: 0.333em;
    padding: 0.5em 1em;
    border: 1px solid #999;
    border-radius: 2px;
    cursor: pointer;
    font-size: 0.88em;
    color: black;
    white-space: nowrap;
    overflow: hidden;
    background-color: #e9e9e9;
    background-image: -webkit-linear-gradient(top, #fff 0%, #e9e9e9 100%);
    background-image: -moz-linear-gradient(top, #fff 0%, #e9e9e9 100%);
    background-image: -ms-linear-gradient(top, #fff 0%, #e9e9e9 100%);
    background-image: -o-linear-gradient(top, #fff 0%, #e9e9e9 100%);
    background-image: linear-gradient(to bottom, #fff 0%, #e9e9e9 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='white', EndColorStr='#e9e9e9');
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-decoration: none;
    outline: none;
    }
    .excel_download_btn:hover{
      color:#000;
    }
    .input-group-addon{
      border-radius: 4px 0 0 4px;
      border-right: 0;
    }
</style>
